import styles from './NotFound.module.css';

function NotFound() {
  return (
    <article id="not-found" className={styles.notFound}>
      <h2>PAGE NOT FOUND</h2>
      <p>The page you are trying to reach does not exist. It may have been moved or deleted.</p>
    </article>
  );
}

export default NotFound;
